<template>
  <section class="container">
    <div class="loader py-5 py-lg-8">
      <div class="loader__item"></div>
      <div class="loader__item"></div>
      <div class="loader__item"></div>
      <h4 class="loader__message" v-if="hasMessage">
        <slot name="message"></slot>
      </h4>
    </div>
  </section>
</template>


<script>
export default {
  computed: {
    hasMessage() {
      return !!this.$slots.message
    },
  }
}
</script>